import React, { useContext, useEffect, useState } from "react";
import { startOfWeek, nextDay } from "date-fns";

import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";

import {
  StyledTableCell,
  StyledTableRow,
} from "components/atoms/table/StyledTable";
import {
  getFormattedDateURL,
  getFormatDate,
} from "components/atoms/dateTime/GetFormattedDate";
import { SnackContext } from "context/SnackProvider";
import instance, { getErrorMessage } from "api/definitions";

const Graph = () => {
  return (
    <Typography
      sx={{ bgcolor: "rgb(0, 74, 173)", width: "50px", height: "20px" }}
    ></Typography>
  );
};

const LocationHourWeekTable = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);

  const snackContext = useContext(SnackContext);

  useEffect(() => {
    setIsLoaded(false);
    if (props.idLocation) {
      const dateURL = getFormattedDateURL(props.date);
      const idUnit = props.idUnit ? "&idUnidade=" + props.idUnit : "";
      const idActivityType = props.idActivityType
        ? "&idAtividadeTipo=" + props.idActivityType
        : "";

      const h1 = props.hourBegin ? "&h1=" + props.hourBegin : "";
      const h2 = props.hourEnd ? "&h2=" + props.hourEnd : "";

      const fullURL = `relatorio/localHoraSemana/${props.idLocation}?date=${dateURL}${idUnit}${idActivityType}${h1}${h2}`;

      instance
        .get(fullURL)
        .then(function (response) {
          setIsLoaded(true);
          const result = response.data;
          setItems(result);
        })
        .catch(function (error) {
          setIsLoaded(true);
          const msg = getErrorMessage(error);
          snackContext.setMessage(msg, "error");
        });
    }
  }, [
    props.idLocation,
    props.date,
    props.idUnit,
    props.idActivityType,
    props.hourBegin,
    props.hourEnd,
    snackContext,
  ]);

  if (props.idLocation) {
    if (!isLoaded) {
      return <CircularProgress />;
    } else {
      const dateSunday = startOfWeek(props.date);
      const dateMonday = nextDay(dateSunday, 1);
      const dateTuesday = nextDay(dateSunday, 2);
      const dateWednesday = nextDay(dateSunday, 3);
      const dateThursday = nextDay(dateSunday, 4);
      const dateFriday = nextDay(dateSunday, 5);
      const dateSaturday = nextDay(dateSunday, 6);

      const values = Object.values(items);

      const valueSunday = Number(values[0]);
      const valueMonday = Number(values[1]);
      const valueTuesday = Number(values[2]);
      const valueWednesday = Number(values[3]);
      const valueThursday = Number(values[4]);
      const valueFriday = Number(values[5]);
      const valueSaturday = Number(values[6]);

      if (
        !valueSunday &&
        !valueMonday &&
        !valueTuesday &&
        !valueWednesday &&
        !valueThursday &&
        !valueFriday &&
        !valueSaturday
      ) {
        return (
          <Typography color="error">
            Com base nos filtros utilizados, não há carga horária para este
            local na semana{" "}
            {`${getFormatDate(dateSunday)} - ${getFormatDate(dateSaturday)}`}.
          </Typography>
        );
      } else {
        let rows = [];
        for (let index = 15; index > 0; index--) {
          rows.push(
            <StyledTableRow key={index}>
              <StyledTableCell sx={{ p: 0 }}>
                {index < 10 && "0"}
                {index}h
              </StyledTableCell>
              <StyledTableCell sx={{ p: 0 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {valueSunday >= index && <Graph />}
                </Box>
              </StyledTableCell>
              <StyledTableCell sx={{ p: 0 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {valueMonday >= index && <Graph />}
                </Box>
              </StyledTableCell>
              <StyledTableCell sx={{ p: 0 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {valueTuesday >= index && <Graph />}
                </Box>
              </StyledTableCell>
              <StyledTableCell sx={{ p: 0 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {valueWednesday >= index && <Graph />}
                </Box>
              </StyledTableCell>
              <StyledTableCell sx={{ p: 0 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {valueThursday >= index && <Graph />}
                </Box>
              </StyledTableCell>
              <StyledTableCell sx={{ p: 0 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {valueFriday >= index && <Graph />}
                </Box>
              </StyledTableCell>
              <StyledTableCell sx={{ p: 0 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {valueSaturday >= index && <Graph />}
                </Box>
              </StyledTableCell>
            </StyledTableRow>
          );
        }

        return (
          <Box sx={{ mb: 2 }}>
            <TableContainer component={Paper}>
              <Table size="small" aria-label="tabela de recursos">
                <TableBody>
                  {rows}
                  <StyledTableRow>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}></StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>DOM</Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>SEG</Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>TER</Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>QUA</Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>QUI</Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>SEX</Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>SAB</Box>
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}></StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>
                        {getFormatDate(dateSunday)}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>
                        {getFormatDate(dateMonday)}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>
                        {getFormatDate(dateTuesday)}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>
                        {getFormatDate(dateWednesday)}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>
                        {getFormatDate(dateThursday)}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>
                        {getFormatDate(dateFriday)}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>
                        {getFormatDate(dateSaturday)}
                      </Box>
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}></StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>{valueSunday}h</Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>{valueMonday}h</Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>{valueTuesday}h</Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>{valueWednesday}h</Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>{valueThursday}h</Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>{valueFriday}h</Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ pt: 0, pb: 0 }}>
                      <Box sx={{ textAlign: "center" }}>{valueSaturday}h</Box>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        );
      }
    }
  }
};

export default LocationHourWeekTable;
